import { useState, useRef, useEffect } from "react"
import ProductsListBgColor from "components/Products/ProductsListBgColor"
import ProductsListBgColorNone from "components/Products/ProductsListBgColorNone"
import ProductsListCombo from "components/Products/ProductsListCombo"

const TOPICS = [
    {
        label: "Lợi Nhuận Cao",
        icon: "https://gcs.buymed.com/thuocsi-live/internal/cms/202418b98d1e9448f4840f3673a3e87dfire_2.svg",
    },
    {
        label: "Mua chung khu vực",
        icon: "https://gcs.buymed.com/thuocsi-live/internal/cms/2025e01efcf65f6c3d4f64cefe926e53Layer_1.svg",
    },
    {
        label: "Combo tiết kiệm",
        icon: "https://gcs.buymed.com/thuocsi-live/internal/cms/2025bc88811049a2bd6888b18fec89c4Coupon.svg",
    },
    {
        label: "Sản Phẩm Mới",
        icon: "https://gcs.buymed.com/thuocsi-live/internal/cms/202538f2f58c5d9e217f7ca783a21340New_products.svg",
    },
]

interface Topic {
    label: string;
    icon: string;
}

export default function RecommendationList() {
    const [active, setActive] = useState(0)
    const sectionRefs = useRef<(HTMLDivElement | null)[]>([])
    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        const index = sectionRefs.current.findIndex(
                            (el) => el === entry.target
                        )
                        if (index !== -1) setActive(index)
                    }
                })
            },
            {
                root: null,
                threshold: 0.4, // 40% section xuất hiện
            }
        )

        sectionRefs.current.forEach((section) => {
            if (section) observer.observe(section)
        })

        return () => observer.disconnect()
    }, [])

    return (
        <section className="product-list-recommendation style_container__eyX8n !px-0">
            <div className="style_listTopic__sTgL5 hidden-1199">
                <div className="style_containerList__XZ48i">
                    {TOPICS.map((item: Topic, index: number) => (
                        <button
                            key={item.label}
                            className={
                                "MuiButtonBase-root style_item__h3a93" +
                                (active === index ? " style_topicActive__7uQwj" : "")
                            }
                            tabIndex={0}
                            type="button"
                            onClick={() => {
                                setActive(index)
                                sectionRefs.current[index]?.scrollIntoView({
                                    behavior: "smooth",
                                    block: "start",
                                })
                            }}
                        >
                            <div className="style_wrapperContent__X3MCA">
                                <span
                                    style={{
                                        boxSizing: "border-box",
                                        display: "inline-block",
                                        overflow: "hidden",
                                        width: "initial",
                                        height: "initial",
                                        background: "none",
                                        opacity: 1,
                                        border: "0px",
                                        margin: "0px",
                                        padding: "0px",
                                        position: "relative",
                                        maxWidth: "100%",
                                    }}
                                >
                                    <span
                                        style={{
                                            boxSizing: "border-box",
                                            display: "block",
                                            width: "initial",
                                            height: "initial",
                                            background: "none",
                                            opacity: 1,
                                            border: "0px",
                                            margin: "0px",
                                            padding: "0px",
                                            maxWidth: "100%",
                                        }}
                                    >
                                        <img
                                            alt=""
                                            aria-hidden="true"
                                            src="data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24'/%3e"
                                            style={{
                                                display: "block",
                                                maxWidth: "100%",
                                                width: "initial",
                                                height: "initial",
                                                background: "none",
                                                opacity: 1,
                                                border: "0px",
                                                margin: "0px",
                                                padding: "0px",
                                            }}
                                        />
                                    </span>

                                    <img
                                        src={item.icon}
                                        alt={item.label}
                                        decoding="async"
                                        style={{
                                            position: "absolute",
                                            inset: "0px",
                                            boxSizing: "border-box",
                                            padding: "0px",
                                            border: "none",
                                            margin: "auto",
                                            display: "block",
                                            width: "0px",
                                            height: "0px",
                                            minWidth: "100%",
                                            maxWidth: "100%",
                                            minHeight: "100%",
                                            maxHeight: "100%",
                                        }}
                                    />
                                </span>

                                {item.label}
                            </div>

                            <span className="MuiTouchRipple-root" />
                        </button>
                    ))}
                </div>
            </div>

            <div className="style_wrapperBlockRandom__gFkZu" style={{ backgroundColor: "rgb(255, 243, 223)" }} ref={(el) => (sectionRefs.current[0] = el)}>
                <div className="style_titleRandom__6zDvj" style={{ backgroundImage: "url(\"https://gcs.buymed.com/thuocsi-live/internal/cms/2024676a926090536e9c1dcdd3328009Frame_1000005601.png\")" }}></div>
                <ProductsListBgColor />
                <div className="style_wrapperButton__99gMW"><a className="" href="/products/JBBCV84F?blockCode=JBBCV84F" style={{ padding: "0px" }}><button className="MuiButtonBase-root style_buttonBase__nATvV" tabIndex={0} type="button" style={{ backgroundColor: "rgb(255, 255, 255)", color: "var(--primary-color)" }}><span className="style_wrapperText__8DV76">Xem thêm <svg className="MuiSvgIcon-root" focusable="false" viewBox="0 0 24 24" aria-hidden="true"><path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"></path></svg></span><span className="MuiTouchRipple-root"></span></button></a></div>
            </div>

            <div className="style_wrapperBlockRandom__gFkZu" style={{ backgroundColor: "rgb(232, 246, 238)" }} ref={(el) => (sectionRefs.current[1] = el)}>
                <div className="style_titleRandom__6zDvj" style={{ backgroundImage: "url('https://gcs.buymed.com/thuocsi-live/internal/cms/2024f2211bf396f83a14623f03da5178Frame_48096294_(3).png')" }}></div>
                <ProductsListBgColorNone />
                <div className="style_wrapperButton__99gMW"><a className="" href="/products/JBBCV84F?blockCode=JBBCV84F" style={{ padding: "0px" }}><button className="MuiButtonBase-root style_buttonBase__nATvV" tabIndex={0} type="button" style={{ backgroundColor: "rgb(255, 255, 255)", color: "var(--primary-color)" }}><span className="style_wrapperText__8DV76">Xem thêm <svg className="MuiSvgIcon-root" focusable="false" viewBox="0 0 24 24" aria-hidden="true"><path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"></path></svg></span><span className="MuiTouchRipple-root"></span></button></a></div>
            </div>
            <div className="style_wrapperBlockRandom__gFkZu" style={{ backgroundColor: "rgb(255, 243, 223)" }} ref={(el) => (sectionRefs.current[2] = el)}>
                <div className="style_titleRandom__6zDvj" style={{ backgroundImage: "url(\"https://gcs.buymed.com/thuocsi-live/internal/cms/2024bc2f5f6e8daaceca81aca846f38dFrame_48096294.jpg\")" }}></div>
                <ProductsListCombo />
                <div className="style_wrapperButton__99gMW"><a className="" href="/products/JBBCV84F?blockCode=JBBCV84F" style={{ padding: "0px" }}><button className="MuiButtonBase-root style_buttonBase__nATvV" tabIndex={0} type="button" style={{ backgroundColor: "rgb(255, 255, 255)", color: "var(--primary-color)" }}><span className="style_wrapperText__8DV76">Xem thêm <svg className="MuiSvgIcon-root" focusable="false" viewBox="0 0 24 24" aria-hidden="true"><path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"></path></svg></span><span className="MuiTouchRipple-root"></span></button></a></div>
            </div>
            <div className="style_wrapperBlockRandom__gFkZu" style={{ backgroundColor: "rgb(227, 235, 239)" }} ref={(el) => (sectionRefs.current[3] = el)}>
                <div className="style_titleRandom__6zDvj" style={{ backgroundImage: "url(\"https://gcs.buymed.com/thuocsi-live/internal/cms/20240781916caa5375cf76c47c024746Frame_48096296.png\")" }}></div>
                <ProductsListBgColorNone />
                <div className="style_wrapperButton__99gMW"><a className="" href="/products/JBBCV84F?blockCode=JBBCV84F" style={{ padding: "0px" }}><button className="MuiButtonBase-root style_buttonBase__nATvV" tabIndex={0} type="button" style={{ backgroundColor: "rgb(255, 255, 255)", color: "var(--primary-color)" }}><span className="style_wrapperText__8DV76">Xem thêm <svg className="MuiSvgIcon-root" focusable="false" viewBox="0 0 24 24" aria-hidden="true"><path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"></path></svg></span><span className="MuiTouchRipple-root"></span></button></a></div>
            </div>
        </section>
    )
}
